import React from "react"

export const PageContext = React.createContext({
  title: "Untitled page",
  actions: <></>
})
